import React from "react";
import { View, Text, StyleSheet, ScrollView, TouchableOpacity } from "react-native";
import SvgIcon from '../components/SvgIcon';
import colors from "../theme/colors";

export default function SuccessStoriesScreen() {
  return (
    <ScrollView style={styles.container} contentContainerStyle={styles.content}>
      <View style={styles.storiesSection}>
        <View style={styles.storiesHeader}>
          <View>
            <Text style={styles.storiesTitle}>Success Stories</Text>
            <Text style={styles.storiesSubtitle}>Real couples, real happiness</Text>
          </View>
          <TouchableOpacity style={styles.viewAllButton}>
            <Text style={styles.viewAllText}>View All</Text>
            <SvgIcon name="chevron-forward" size={16} color={colors.secondary} />
          </TouchableOpacity>
        </View>
        
        <View style={styles.storyCard}>
          <Text style={styles.storyNames}>Priya & Rahul</Text>
          <Text style={styles.storyText}>
            "We found each other through KalyanaMitra. The mediator guidance was invaluable in our journey."
          </Text>
        </View>
        
        <View style={styles.storyCard}>
          <Text style={styles.storyNames}>Anjali & Vikram</Text>
          <Text style={styles.storyText}>
            "Traditional values with modern approach - that's what we loved about KalyanaMitra!"
          </Text>
        </View>

        <View style={styles.storyCard}>
          <Text style={styles.storyNames}>Meera & Arjun</Text>
          <Text style={styles.storyText}>
            "The AI compatibility matching combined with personal mediator touch made all the difference."
          </Text>
        </View>

        <View style={styles.storyCard}>
          <Text style={styles.storyNames}>Divya & Karthik</Text>
          <Text style={styles.storyText}>
            "Our mediator understood exactly what we were looking for. Found our perfect match within weeks!"
          </Text>
        </View>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.white,
  },
  content: {
    paddingBottom: 120,
  },
  storiesSection: {
    width: "100%",
    paddingHorizontal: 24,
    paddingVertical: 50,
    backgroundColor: colors.white,
  },
  storiesHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 30,
  },
  storiesTitle: {
    fontSize: 28,
    fontWeight: "700",
    color: colors.primary,
    marginBottom: 4,
  },
  storiesSubtitle: {
    fontSize: 14,
    color: colors.textDark,
  },
  viewAllButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  viewAllText: {
    fontSize: 14,
    color: colors.secondary,
    fontWeight: "600",
  },
  storyCard: {
    backgroundColor: colors.gray100,
    borderRadius: 12,
    padding: 20,
    marginBottom: 16,
  },
  storyNames: {
    fontSize: 16,
    fontWeight: "600",
    color: colors.primary,
    marginBottom: 8,
  },
  storyText: {
    fontSize: 14,
    color: colors.textDark,
    lineHeight: 22,
    fontStyle: "italic",
  },
  ctaSection: {
    width: "100%",
    paddingHorizontal: 24,
    paddingVertical: 60,
    backgroundColor: colors.primary,
    alignItems: "center",
  },
  ctaTitle: {
    fontSize: 32,
    fontWeight: "700",
    color: colors.white,
    textAlign: "center",
    marginBottom: 8,
  },
  ctaSubtitle: {
    fontSize: 16,
    color: colors.white,
    opacity: 0.8,
    textAlign: "center",
    marginBottom: 32,
  },
  ctaButtons: {
    flexDirection: "column",
    gap: 16,
    width: "100%",
  },
  ctaButtonPrimary: {
    backgroundColor: colors.secondary,
    paddingHorizontal: 32,
    paddingVertical: 16,
    borderRadius: 8,
    alignItems: "center",
  },
  ctaButtonSecondary: {
    backgroundColor: "transparent",
    borderWidth: 2,
    borderColor: colors.secondary,
    paddingHorizontal: 32,
    paddingVertical: 16,
    borderRadius: 8,
    alignItems: "center",
  },
  ctaButtonText: {
    color: colors.white,
    fontSize: 16,
    fontWeight: "600",
  },
  ctaButtonTextSecondary: {
    color: colors.secondary,
    fontSize: 16,
    fontWeight: "600",
  },
});
